import { render, staticRenderFns } from "./CommentPassport.vue?vue&type=template&id=2c796de2"
import script from "./CommentPassport.vue?vue&type=script&lang=js"
export * from "./CommentPassport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports